module.exports = __webpack_public_path__ + "img/edit-white-icon.f50cfed1.svg";